import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';

// Public web config; safe to ship to the browser.
const firebaseConfig = {
  projectId: 'friendlai-62296',
  appId: '1:340372337298:web:e36295c62aa6af0cf26c4b',
  storageBucket: 'friendlai-62296.firebasestorage.app',
  apiKey: 'AIzaSyDr3EW-ZdPR62BLoDVbfS4jiS4y1EsC8Mo',
  authDomain: 'friendlai-62296.firebaseapp.com',
  messagingSenderId: '340372337298',
  measurementId: 'G-6FNWY6L7QL',
};

/** Browser-only. Firebase Auth relies on browser storage, so never call this during SSR. */
export function firebaseAuth(): Auth {
  const app: FirebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
  return getAuth(app);
}
